<div class="standard-dialog">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ (isEditMode ? 'GroupOverview.UpdateGroup' : 'GroupOverview.CreateGroup') | translate }}</h2>
      <p class="subtitle">{{ 'GroupOverview.Subtitle' | translate }}</p>
    </div>
    <button mat-icon-button (click)="onCancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="form-content">
    <div class="w-100">
      <mat-label class="form-label mb-1">{{ 'Global.Name' | translate }}</mat-label>
      <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
        <input matInput [(ngModel)]="groupName" [placeholder]="'GroupOverview.EnterGroupName' | translate" required />
      </mat-form-field>
    </div>

    <div class="w-100">
      <mat-label class="form-label mb-1">{{ 'Global.Description' | translate }}</mat-label>
      <mat-form-field subscriptSizing="dynamic" appearance="fill" class="w-100">
        <textarea matInput [(ngModel)]="groupDescription" [placeholder]="'GroupOverview.EnterGroupDescription' | translate" rows="4"></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <div class="left-actions"></div>
    <div class="right-actions">
      <button mat-flat-button btnType="neutral" (click)="onCancel()">{{ 'Global.Cancel' | translate }}</button>
      <button mat-flat-button btnType="action" (click)="onSave()" [disabled]="!groupName || loading">
        {{ 'Global.Save' | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
